export default {
    'ERROR-GET-USER-CHALLENGES-ADMIN': {
        'USER-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Le challenge demandé est introuvable.",
                en: 'The requested challenge was not found.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-NOT-DONE': {
            actionType: 'toast',
            message: {
                fr: "Le challenge n'est pas terminé.",
                en: 'The challenge is not completed.',
            },
        },
        'USER-CHALLENGE-ALREADY-VALIDATED-OR-REFUSED': {
            actionType: 'toast',
            message: {
                fr: "Le challenge a déjà été validé ou refusé.",
                en: 'The challenge has already been validated or refused.',
            },
        },
        'USER-CHALLENGE-NO-CHALLENGE': {
            actionType: 'redirect',
            message: {
                fr: "Aucun challenge associé trouvé pour cet utilisateur.",
                en: 'No associated challenge found for this user.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-NO-HELPER': {
            actionType: 'redirect',
            message: {
                fr: "Aucun utilisateur associé trouvé pour ce challenge.",
                en: 'No associated user found for this challenge.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-ALREADY-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Le challenge est déjà dans cet état.",
                en: 'The user challenge is already in this status.',
            },
        },
        'USER-CHALLENGE-INVALID-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Statut invalide pour le challenge.",
                en: 'Invalid status for the challenge.',
            },
        },
    },
    'ERROR-VALIDATE-CHALLENGE-ADMIN': {
        'USER-CHALLENGE-NOT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Le challenge demandé est introuvable.",
                en: 'The requested challenge was not found.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-NOT-DONE': {
            actionType: 'toast',
            message: {
                fr: "Le challenge n'est pas terminé.",
                en: 'The challenge is not completed.',
            },
        },
        'USER-CHALLENGE-ALREADY-VALIDATED-OR-REFUSED': {
            actionType: 'toast',
            message: {
                fr: "Le challenge a déjà été validé ou refusé.",
                en: 'The challenge has already been validated or refused.',
            },
        },
        'USER-CHALLENGE-NO-CHALLENGE': {
            actionType: 'redirect',
            message: {
                fr: "Aucun challenge associé trouvé pour cet utilisateur.",
                en: 'No associated challenge found for this user.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-NO-HELPER': {
            actionType: 'redirect',
            message: {
                fr: "Aucun utilisateur associé trouvé pour ce challenge.",
                en: 'No associated user found for this challenge.',
            },
            redirectPath: '/challenges/overview',
        },
        'USER-CHALLENGE-ALREADY-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Le challenge est déjà dans cet état.",
                en: 'The challenge is already in this status.',
            },
        },
        'USER-CHALLENGE-INVALID-STATUS': {
            actionType: 'toast',
            message: {
                fr: "Statut invalide pour le challenge.",
                en: 'Invalid status for user challenge.',
            },
        },
    },
};
